import { computed } from "vue";
import { useStore } from "vuex";

function normalizeEntry(entry) {
  if (!entry || typeof entry !== "object") {
    // TODO: Current fallback is fail-open. In the future this should move to a hybrid
    // fail-closed policy for critical services/features while keeping safe areas fail-open.
    return { enabled: true, mode: "enabled", message: "" };
  }

  const enabled = entry.enabled !== false;
  const mode = entry.mode || (enabled ? "enabled" : "disabled");
  const message = entry.message || entry.reason || "";

  return {
    ...entry,
    enabled,
    mode,
    message,
  };
}

export function useAvailability() {
  const store = useStore();

  const availability = computed(() => store.getters.getAvailability);

  function getDomain(domainKey) {
    return availability.value?.domains?.[domainKey] || {};
  }

  function getServiceEntry(serviceKey) {
    return normalizeEntry(availability.value?.services?.[serviceKey]);
  }

  function getFeatureEntry(featureKey) {
    return normalizeEntry(availability.value?.features?.[featureKey]);
  }

  function getDomainItemEntry(domainKey, collectionKey, itemKey) {
    return normalizeEntry(getDomain(domainKey)?.[collectionKey]?.[itemKey]);
  }

  function isServiceAvailable(serviceKey) {
    return getServiceEntry(serviceKey).enabled;
  }

  function isFeatureAvailable(featureKey) {
    return getFeatureEntry(featureKey).enabled;
  }

  return {
    availability,
    getServiceEntry,
    getFeatureEntry,
    getDomainItemEntry,
    getDomain,
    isServiceAvailable,
    isFeatureAvailable,
  };
}
